import { graphql } from '../gql';

export const projectNotification = graphql(/* GraphQL */ `
    mutation serviceRequestNotification($input: ServiceRequestNotificationInput!) {
        serviceRequestNotification(input: $input) {
            id
            message
        }
    }
`);

export const onServiceRequestNotification = graphql(/* GraphQL */ `
    subscription onServiceRequestNotification {
        onServiceRequestNotification {
            id
            message
        }
    }
`);
